const messages = {
  title: "Bolt",
  description: "Üdvözöljük a jutalomboltban. Itt válthatod be Bridgestone Plus-pontjaidat <br/> különböző kategóriákból származó jutalmakra. A termékpaletta <br/> rendszeresen frissül. Reméljük, hogy élvezni fogja a böngészést.",
  sort: {
    asc: "Rendezés: Legalacsonyabb ár",
    desc: "Rendezés: Legmagasabb ár",
  },
  productSearchBox: {
    from: "pontoktól",
    to: "pontokig",
  },
  noProducts: "A keresési feltételek nem adtak eredményt",
  quantity: "Mennyiség",
  search: "Keresés",
  perPage: "Elemek oldalanként",
  timeUnavailable: "Jelenleg nem elérhető",
  product: "Termék",
  cart: {
    pointsPerUnit: "Pont / egység",
    pointsSum: "Pontok összege",
  },
  action: "Művelet",
  pointsTotal: "Összesen",
  cartRemainPoints: "Maradék pontok a kosárban",
  shoppingCart: "Bevásárlókosár",
  emptyCart: "A kosár üres.",
  attributes: "Attribútumok",
  selectAddressP: "Kérjük, válassza ki a szállítási címet",
  orderDelivery: "Szállítási cím",
  selectedProducts: "Kiválasztott termékek",
  orderSummary: "Rendelés áttekintése",
  contactPerson: "Kapcsolattartó",
  selectedAddress: "Kiválasztott cím",
  order: {
    success: "Köszönjük! A rendelése sikeres volt. Néhány percen belül megkapja a rendelés visszaigazolását a postaládájában.",
    description: "Itt találja a jutalombolt rendeléseinek áttekintését.",
    info: "Itt találja a jutalombolt rendeléseinek áttekintését.",
    date: "Rendelés dátuma",
    number: "Rendelés száma",
    status: {
      created: "Létrehozva",
      confirm_order: "Rendelés megerősítése",
      ready_for_shipment: "Szállításra kész",
      rejected: "Elutasítva",
      processed: "Feldolgozva",
      shipped: "Elküldve",
      returned: "Visszaküldve",
      finished: "Befejezve",
    },
    anyOrder: "Nincsenek rendelések",
    products: "Termékek",
    quantity_short: "db",
    itemRemoved: "nem szállítható",
  },
  orders: "Rendelések",
  notEnoughPoints: "Nincs elegendő elérhető pontja.",
  statusText: "Állapot",
  outOfStock: "Jelenleg nincs raktáron",
  productUnavailable: "Ez a termék már nem elérhető.",
  deletedProductsTitle: "A termékek már nem elérhetők",
  deletedProductsMessage: "A következő termékek már nem elérhetők. Távolítsa el őket a kosárból a folytatáshoz.",
  removeSelected: "Kijelöltek eltávolítása",
  clearCart: "Kosár ürítése",
  removeSelectedConfirm: "Eltávolítja a kijelölt termékeket a kosárból?",
  clearCartConfirm: "Eltávolítja az összes terméket a kosárból?",
  incompleteAddress: {
    firstName: "Kérjük, adjon meg keresztnevet a szállítási címhez",
    lastName: "Kérjük, adjon meg vezetéknevet a szállítási címhez",
    company: "Kérjük, adjon meg cégnevet a szállítási címhez",
    street: "Kérjük, adjon meg utcát és házszámot a szállítási címhez",
    postalCode: "Kérjük, adjon meg irányítószámot a szállítási címhez",
    city: "Kérjük, adjon meg várost a szállítási címhez",
    country: "Kérjük, adjon meg országot a szállítási címhez",
    phone: "Kérjük, adjon meg telefonszámot a szállítási címhez",
  },
  placeOrder: "Kötelező érvényű rendelés",
  toOrderDelivery: "Tovább a szállítási címhez",
  toOrderSummary: "A rendelés áttekintéséhez",
  productImg: "Termékkép",
  selectAddressBtn: "Cím kiválasztása",
  perPgae: "Elemek oldalanként",
  categories: {
    advertising: {
      title: "Reklámanyagok",
      desc: "Vegyen részt közvetlenül itt a platformon, és szerezzen <br/> 40 extra pontot a jutalomklubhoz.",
    },
    rewards: {
      title: "Exkluzív jutalmak",
      desc: "Fedezze fel a bónusz ajánlatot képzési központunkban vagy az Ön telephelyén.",
    },
    tools: {
      title: "Műhelyszerszámok",
      desc: "Használja pontjait harmadik fél képzéseire <br/> és csökkentse költségeit.",
    },
    trainings: {
      title: "Képzések és tanfolyamok",
      desc: "Fedezze fel a bónusz ajánlatot képzési központunkban vagy az Ön telephelyén.",
    },
    salesroom: {
      title: "Értékesítési tér",
      desc: "Rendezze be az értékesítési teret, és kínáljon kellemes tartózkodást ügyfeleinek.",
    },
    hunter: {
      title: "Hunter",
      desc: "Cserélje be pontjait vonzó Hunter műhelyfelszerelésre.",
    },
  },
  bestSold: "Legtöbbet eladott",
  seasonal: "Szezonális",
  affordable: "Majdnem kész",
  forPoints: "{points} pontért",
  reachedPoints: "A szükséges pontok elérve",
  remainingPoints: "{points} pont hiányzik",
  favoriteProducts: {
    description: "Itt találja a mentett termékeket.",
  },
  categoryPageDescriptionFallback: "Anyagok a műhelybe vagy más minőségi termékek Bridgestone logóval vállalkozása számára",
  variant: "Választható változatok",
};
export default {
  messages,
};
